<template>
    <div>
        <router-view v-slot="{ Component }">
            <component :is="Component" />
        </router-view>

        <button class="scroll-top" aria-label="Scroll to top" :class="{'visible': scrollTopVisible }" type="button" @click="scrollToTop">
            <BaseIcon name="caret_up" size="26" />
        </button>

        <ModalWrapper/>
    </div>
</template>

<script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue';
    let scrollTopVisible = ref(false);

    onMounted(() => {
        window.addEventListener('scroll', catchScroll, {passive: true});
    });

    function catchScroll(){
        const pastTopOffset = window.pageYOffset > 300;
        scrollTopVisible.value = pastTopOffset;
    }

    function scrollToTop(){
        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
        });
    }

    onBeforeUnmount(() => {
        window.removeEventListener('scroll', catchScroll);
    });
</script>